import { canvasPreview } from "./canvasPreview";

export function imgPreviewBase64(image, crop, scale = 1, rotate = 0) {
  const canvas = document.createElement("canvas");
  canvasPreview(image, canvas, crop, scale, rotate);

  return new Promise((resolve) => {
    const imageData = canvas.toDataURL("image/jpeg", 0.7);
    resolve(imageData);
  });
}
